<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		[isExportable]="isExportable"
	></app-nav-gestion-donnees>

	<!-- <input hidden type="file" #uploader (change)="importMissionPlaces($event)" /> -->
	<div class="row my-3">
		<div class="row my-2">
			<div class="col-auto">
				<button
					class="btn theme-main-color-button"
					(click)="importFromOcashe()"
				>
					<i class="bi bi-cloud-download" aria-hidden="true"></i> Importer
					depuis OCASHE
				</button>
			</div>

			<div class="col-2 ms-lg-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						role="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
						<!-- Filtre par service -->
						<div class="mb-3">
							<label class="form-label">Service</label>
							<select
								class="form-select"
								[(ngModel)]="selectedService"
								(change)="filterParcours()"
							>
								<option [ngValue]="null">Tous</option>
								<option
									*ngFor="let service of availableServices"
									[value]="service"
								>
									{{ service }}
								</option>
							</select>
						</div>

						<!-- Filtre par type de module -->
						<div class="mb-3">
							<label class="form-label">Type de module</label>
							<select
								class="form-select"
								[(ngModel)]="selectedModuleType"
								(change)="filterParcours()"
							>
								<option [ngValue]="null">Tous</option>
								<option
									*ngFor="let type of availableModuleTypes"
									[value]="type"
								>
									{{ type }}
								</option>
							</select>
						</div>

						<!-- Filtre par état de planification -->
						<div class="mb-3">
							<label class="form-label">État de planification</label>
							<select
								class="form-select"
								[(ngModel)]="selectedPlanningState"
								(change)="filterParcours()"
							>
								<option value="ALL">Tous</option>
								<option value="PLANNED">Planifiés</option>
								<option value="UNPLANNED">À planifier</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-4 col-12 ps-lg-3 mt-2 mt-lg-0">
				<div class="input-group">
					<span class="input-group-text bg-transparent">
						<i class="bi bi-search" aria-hidden="true"></i>
					</span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Rechercher par n° de dossier ou nom/prénom"
						[(ngModel)]="searchedInput"
						(keyup)="filterParcours()"
					/>
				</div>
			</div>

			<!-- <div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s), adresse"
						[(ngModel)]="searchedInput"
						(keyup)="onKeyUp()"
					/>
				</div>
			</div> -->
		</div>

		<div class="row mt-4" *ngIf="!isMobile">
			<div class="col-lg-3 col-12">
				<span class="ps-1 fw-bold">N° Dossier DH</span>
			</div>
			<div class="col-lg-3 col-12">
				<span class="ps-1 fw-bold">Service</span>
			</div>
			<!-- <div class="col-lg-2 col-12">
				<span class="ps-1 fw-bold">Date de démarrage</span>
			</div>
			<div class="col-lg-2 col-12">
				<span class="ps-1 fw-bold">Date limite d'exécution</span>
			</div>
			<div class="col-lg-1 col-12">
				<span class="ps-1 fw-bold">Durée</span> 
			</div> -->
			<div class="col-lg-3 col-12">
				<span class="ps-1 fw-bold">Module(s)</span>
			</div>
			<div class="col-lg-3 col-12">
				<span class="ps-1 fw-bold">Bénéficiaire</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let p of filteredParcours
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-3 col-12">
					<span *ngIf="isMobile" class="fw-bold">N° Dossier DH :</span>
					{{ p?.idDemandDH }}
				</span>

				<span class="col-lg-3 col-12">
					<span *ngIf="isMobile" class="fw-bold">Service :</span>
					{{ p?.service?.name }}
				</span>

				<!-- <span class="col-lg-2 col-12">
					<span *ngIf="isMobile" class="fw-bold">Démarrage :</span>
					{{ p?.startDate | date : 'dd/MM/yyyy' }}
				</span>

				<span class="col-lg-2 col-12">
					<span *ngIf="isMobile" class="fw-bold">Limite :</span>
					{{ p?.limitExecDate | date : 'dd/MM/yyyy' }}
				</span>

				<span class="col-lg-1 col-12">
					<span *ngIf="isMobile" class="fw-bold">Durée :</span>
					{{ p?.plannedDuration }}
				</span> -->

				<span class="col-lg-3 col-12">
					<span *ngIf="isMobile" class="fw-bold">Module(s) :</span>
					<ng-container *ngFor="let module of p?.modules">
						<button
							class="btn me-1 position-relative"
							[ngClass]="
								module.missions?.length
									? 'theme-green-button'
									: 'theme-main-color-button'
							"
							[attr.title]="
								module.missions?.length
									? module.missions.length + ' mission(s)'
									: 'Aucune mission'
							"
							(click)="onModuleClick(module, p)"
						>
							<span class="default-text">
								{{ module.type }}
							</span>
							<span class="hover-text" *ngIf="!module.missions?.length">
								<i class="bi bi-calendar-plus"></i> Planifier
							</span>
							<span class="hover-text" *ngIf="module.missions?.length > 0">
								<i class="bi bi-calendar-check"></i> Planifié
							</span>
						</button>
					</ng-container>
				</span>

				<div class="col-lg-3 col-12 d-flex">
					<div class="flex-grow-1">
						<span *ngIf="isMobile" class="fw-bold">Bénéficiaire :</span>
						{{ p?.beneficiaire?.firstName }} {{ p?.beneficiaire?.lastName }}
					</div>

					<!-- Icône de détail -->
					<i
						[routerLink]="['/gestion/parcours', p?.id]"
						role="button"
						class="fs-4 bi bi-caret-right-fill mb-1"
						aria-hidden="true"
					></i>
				</div>
			</div>
			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				>
				</pagination-controls>
				<div class="d-flex justify-content-center">
					<label class="form-label mt-2 mx-2">Elements par page</label>
					<div class="">
						<select
							[(ngModel)]="itemsPerPage"
							#ctrl="ngModel"
							(change)="currentPage = 1"
							[ngModelOptions]="{ standalone: true }"
							class="form-select"
						>
							<option *ngIf="parcours?.length >= 1" [value]="10">10</option>
							<option *ngIf="parcours?.length >= 10" [value]="26">26</option>
							<option *ngIf="parcours?.length >= 26" [value]="50">50</option>
							<option *ngIf="parcours?.length >= 50" [value]="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
